function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "p.0"
}, React.createElement("path", {
  d: "m0 0l500.0 0l0 500.0l-500.0 0l0 -500.0z",
  clipRule: "nonzero"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m0 0l500.0 0l0 500.0l-500.0 0z",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m79.467354 27.985443l0 0c0 -11.064495 8.969543 -20.034039 20.034042 -20.034039l300.9949 0c5.3133545 0 10.409088 2.1107235 14.166199 5.867834c3.7571106 3.7571115 5.8678284 8.852847 5.8678284 14.166205l0 444.03027c0 11.064484 -8.969543 20.034027 -20.034027 20.034027l-300.9949 0c-11.064499 0 -20.034042 -8.969543 -20.034042 -20.034027z",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m79.467354 27.985443l0 0c0 -11.064495 8.969543 -20.034039 20.034042 -20.034039l300.9949 0c5.3133545 0 10.409088 2.1107235 14.166199 5.867834c3.7571106 3.7571115 5.8678284 8.852847 5.8678284 14.166205l0 444.03027c0 11.064484 -8.969543 20.034027 -20.034027 20.034027l-300.9949 0c-11.064499 0 -20.034042 -8.969543 -20.034042 -20.034027z",
  fillRule: "evenodd"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m92.02476 40.719414l316.0048 0l0 418.79892l-316.0048 0z",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 3,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m92.02476 40.719414l316.0048 0l0 418.79892l-316.0048 0z",
  fillRule: "evenodd"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m240.47638 474.05487l0 0c0 -5.2919617 4.276184 -9.58197 9.551117 -9.58197l0 0c2.5331116 0 4.9624786 1.0095215 6.753662 2.806488c1.7911682 1.7969666 2.7974548 4.234192 2.7974548 6.775482l0 0c0 5.291992 -4.276184 9.582001 -9.551117 9.582001l0 0c-5.274933 0 -9.551117 -4.2900085 -9.551117 -9.582001z",
  fillRule: "evenodd"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m240.47638 474.05487l0 0c0 -5.2919617 4.276184 -9.58197 9.551117 -9.58197l0 0c2.5331116 0 4.9624786 1.0095215 6.753662 2.806488c1.7911682 1.7969666 2.7974548 4.234192 2.7974548 6.775482l0 0c0 5.291992 -4.276184 9.582001 -9.551117 9.582001l0 0c-5.274933 0 -9.551117 -4.2900085 -9.551117 -9.582001z",
  fillRule: "evenodd"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  d: "m246.67372 23.890512l0 0c0 -1.8321686 1.48526 -3.3174324 3.3174286 -3.3174324l0 0c0.87983704 0 1.7236481 0.349514 2.3457794 0.971653c0.6221466 0.622139 0.97164917 1.4659405 0.97164917 2.3457794l0 0c0 1.8321667 -1.48526 3.3174324 -3.3174286 3.3174324l0 0c-1.8321686 0 -3.3174286 -1.4852657 -3.3174286 -3.3174324z",
  fillRule: "evenodd"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 1,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m246.67372 23.890512l0 0c0 -1.8321686 1.48526 -3.3174324 3.3174286 -3.3174324l0 0c0.87983704 0 1.7236481 0.349514 2.3457794 0.971653c0.6221466 0.622139 0.97164917 1.4659405 0.97164917 2.3457794l0 0c0 1.8321667 -1.48526 3.3174324 -3.3174286 3.3174324l0 0c-1.8321686 0 -3.3174286 -1.4852657 -3.3174286 -3.3174324z",
  fillRule: "evenodd"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m354.04724 3.8174613l34.362213 0l0 5.1023626l-34.362213 0z",
  fillRule: "evenodd"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m354.04724 3.8174613l34.362213 0l0 5.1023626l-34.362213 0z",
  fillRule: "evenodd"
});

var SvgIOs = function SvgIOs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0.0 0.0 500.0 500.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIOs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iOS.18c93ea2.svg";
export { ForwardRef as ReactComponent };